/** Minimum password length enforced by the UI (Supabase may enforce its own). */
export const MIN_PASSWORD_LENGTH = 8;

export const GENERIC_AUTH_ERROR = 'Ocurrió un error. Por favor intenta nuevamente.';

/**
 * Validates a new password + confirmation pair.
 * Returns a Spanish message or null when the pair is acceptable.
 */
export function validateNewPassword(password: string, confirmation: string): string | null {
  if (!password || !confirmation) return 'Completa ambos campos.';
  if (password.length < MIN_PASSWORD_LENGTH) return `La contraseña debe tener al menos ${MIN_PASSWORD_LENGTH} caracteres.`;
  if (password !== confirmation) return 'Las contraseñas no coinciden.';
  return null;
}

/** Maps Supabase auth / network errors to user-facing Spanish messages. */
export function authErrorMessage(error: unknown): string {
  if (!error) return GENERIC_AUTH_ERROR;
  const err = error as { code?: string; status?: number; message?: string; name?: string };
  const code = (err.code || '').toLowerCase();
  const message = (err.message || (typeof error === 'string' ? error : '')).toLowerCase();
  const name = (err.name || '').toLowerCase();

  if (code === 'invalid_credentials' || message.includes('invalid login credentials')) {
    return 'Correo o contraseña incorrectos.';
  }
  if (code === 'email_not_confirmed' || message.includes('email not confirmed')) {
    return 'Tu correo aún no está confirmado. Revisa tu bandeja de entrada.';
  }
  if (
    err.status === 429 ||
    code.startsWith('over_') ||
    message.includes('rate limit') ||
    message.includes('too many requests') ||
    message.includes('for security purposes')
  ) {
    return 'Demasiados intentos. Espera unos minutos e inténtalo de nuevo.';
  }
  if (code === 'same_password' || message.includes('different from the old password')) {
    return 'La nueva contraseña debe ser distinta de la actual.';
  }
  if (code === 'weak_password' || message.includes('password should') || message.includes('weak password')) {
    return 'La contraseña es demasiado débil. Usa al menos 8 caracteres combinando letras y números.';
  }
  if (code === 'session_not_found' || name === 'authsessionmissingerror' || message.includes('session missing')) {
    return 'Tu sesión expiró. Solicita un nuevo enlace para restablecer tu contraseña.';
  }
  if (
    name === 'authretryablefetcherror' ||
    message.includes('failed to fetch') ||
    message.includes('network') ||
    message.includes('load failed')
  ) {
    return 'No pudimos conectar con el servidor. Revisa tu conexión e inténtalo de nuevo.';
  }
  return GENERIC_AUTH_ERROR;
}
